import { render, staticRenderFns } from "./BtnAtualizarLicitacao.vue?vue&type=template&id=3e4ac92b"
import script from "./BtnAtualizarLicitacao.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarLicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports